export const MAX_SEARCH_TEXT_LENGTH = 100;

/**
 * 서버(`normalize_search_text`)와 같은 기준으로 서버가 받는 검색어인지 본다: trim → NFKC 정규화 뒤
 * **코드포인트** 1~100개, NUL 없음. UTF-16 길이로 세면 이모지처럼 두 단위인 글자를 서버보다 엄격하게 막고,
 * 정규화로 늘어나는 글자(예: ㌀ → 4자)는 서버가 거부하는데도 통과시킨다.
 */
export function isValidSearchText(raw: string): boolean {
  const normalized = raw.trim().normalize('NFKC');
  const length = Array.from(normalized).length; // 코드포인트 수(서버 len과 같다)
  return length >= 1 && length <= MAX_SEARCH_TEXT_LENGTH && !normalized.includes('\u0000');
}
/** 보낼 검색어: trim만 한다(정규화는 서버가 한다). 비었으면 null. */
export const searchTextToSend = (raw: string | null | undefined): string | null => {
  const trimmed = raw?.trim() ?? '';
  return trimmed === '' ? null : trimmed;
};
